class MbRiseGiftCardVariantSelects extends VariantSelects {
    constructor() {
      super();
    }

    onVariantChange() {
        super.onVariantChange();
        if(this.currentVariant != null) {
          var elems = document.querySelectorAll('mb-rise-giftcard-variant-radios input[type=radio]');

          for(var i = 0; i < elems.length; i ++){
              elems[i].checked = false;
          }
        }
    }  

}
  
  customElements.define('mb-rise-giftcard-variant-selects', MbRiseGiftCardVariantSelects);

class MbRiseGiftCardVariantRadios extends VariantRadios {
    constructor() {
      super();
    }

    onVariantChange() {
        super.onVariantChange();
        //console.log(this.currentVariant);

        var elem = document.querySelector('mb-rise-giftcard-variant-selects select');
        if(elem)
          elem.value = '';
    }
  }
  
  customElements.define('mb-rise-giftcard-variant-radios', MbRiseGiftCardVariantRadios);





if (!customElements.get('spa-product-form')) {
  customElements.define('spa-product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.modal = document.querySelector("#ConfirmPopupModal");
      this.openButton = document.querySelector('form .product-form__submit button');
      this.confirmButton = document.querySelector("#ConfirmPopupModal .confirm-submit");
      this.confirmButton.addEventListener('click', this.onConfirmHandler.bind(this));

      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onConfirmHandler(evt) {
      evt.preventDefault();

      //If form has error
      if(this.validateForm()){
        return
      }
      
      
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      
      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      // const parentPage = document.getElementById('parent-page');
      // const parentPageName = parentPage.getAttribute('parent-page');
      // if (parentPageName === "gift-treatments"){
      //    //If this variable exists in .liquid (for example 'totalAmount' exists in gift-treatments.liquid)
      //    if(totalAmount){
      //      let totalPrice = Number(totalAmount);
      //      totalPrice = totalPrice.toFixed(2);
           
      //      fetch('/apps/booking/erp/rise/GetOrCreateCustomCertificateVariant/' + totalPrice, {
      //         method: 'POST',
      //         headers: {'Accept': 'application/json', 'Content-Type': 'application/json'}
      //      })
      //        .then((response) => response.clone().json())
      //        .then((response) => {
      //          if (response.id.length <= 0 && productsInCart.length <= 0) {
      //             this.submitButton.classList.remove('loading');
      //             if (this.cart && this.cart.classList.contains('is-empty'))
      //               this.cart.classList.remove('is-empty');
      //             if (!this.error) 
      //               this.submitButton.removeAttribute('aria-disabled');
      //             this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      //             return;
      //          }
      //          document.getElementById('product-variant-id').value = response.id;
      //          document.getElementById('chosen_products').value = productsInCart.join(',');
              
      //          setTimeout(() => {
      //            this.fetchForm()
      //          }, 3000)
      //        });
      //    }
      // } else {
      //   this.fetchForm()
      // }

     this.fetchForm();
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if(this.validateForm()){
        return
      }

      this.modal.show(this.openButton);
      
    }

    fetchForm(){
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
    
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }

        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          // window.location = window.routes.cart_url;
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          this.modal.hide();
        });
    }

    handleErrorMessage(errorMessage = false) {
      console.log(errorMessage)
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      
      if (errorMessage) {
        this.errorMessageWrapper.style.display = 'flex';
        this.errorMessage.textContent = errorMessage;
      } else {
        this.errorMessageWrapper.style.display = 'none';
      }
    }

   //   function Get() {
   //       var Form = document.getElementById('Form');
		 // var errors = [];
   //       for(I = 0; I < Form.length; I++) {
			//  if(Form[I].type != "submit") {
			//      var Value = Form[I].value;
			// 	 if(Form[I].type == "select-one" && Value == "default") {
			// 	    errors.push("State is required");
			// 	   console.log("State is required");
			// 	 }
				 
			//      if(Value.length <= 1){
			// 	   errors.push(Form[I].placeholder + " is required");
			// 	   console.log(Form[I].placeholder + " is required");
			//      }              
			//   }
   //          }
   //      }
    
    validateForm() {
      let senderName = document.getElementById("senders_name").value;
      let recipientName = document.getElementById("recipients_name").value;
      let shipToName = document.getElementById("ship_to_name").value;
      let shipToAddress = document.getElementById("ship_to_address").value;
      let shipToCity = document.getElementById("ship_to_city").value;
      let shipToZip = document.getElementById("ship_to_zip").value;
      let shipToState = document.getElementById("ship_to_state");
      let errorMessages = {
        "senders_name" : "Sender's Name is required",
        "recipients_name" : "Recipient's Name is required",
        "ship_to_name" : "Ship to Name is required",
        "ship_to_address" : "Address is required",
        "ship_to_city" : "City is required",
        "ship_to_zip" : "Zip is required",
        "ship_to_state" : "State is required"
      }

      let objectsIdsForValidate = [
        "senders_name",
        "recipients_name",
        "ship_to_name",
        "ship_to_address",
        "ship_to_city",
        "ship_to_zip",
        "ship_to_state"
      ]

      let hasErrors = false;

      for(let i = 0; i < objectsIdsForValidate.length; i++){
        let elem = document.getElementById(objectsIdsForValidate[i]);
        if(elem.value.length <= 1) {
          this.handleErrorMessage(errorMessages[objectsIdsForValidate[i]]);
          hasErrors = true;
          break;
        }
      }

      return hasErrors;
    
  // if (isNaN(x) || x < 1 || x > 10) {
  //   text = "Input not valid";
  // } else {
  //   text = "Input OK";
  // }
  // document.getElementById("demo").innerHTML = text;
  
  // if (x == "") {
  //   alert("Name must be filled out");
  //   return false;
  // }
  }
  });
}


class CustomTabBar extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('.tab-button--desktop'); 
    this.tabs.forEach(tab => tab.addEventListener('click', this.handleTabOnClick.bind(this)), );
    this.panels = document.querySelectorAll('.treatment_item');
    this.liquidName = this.getAttribute("liquid-name");
    this.treatmentAddons;
    
    if(this.liquidName === "salon-services"){
      this.treatmentAddons = document.querySelector(".treatment-list-addons");
    }
  }

  handleTabOnClick (e) {
    e.stopPropagation();
    const isActive =  e.target.ariaSelected;
  
    if(isActive === 'false') {
      this.tabs.forEach(tab => tab.ariaSelected = false);
      this.panels.forEach(panel => panel.style.display = "none");
      e.target.ariaSelected = isActive === 'false' ? 'true' : 'false';
      // this.panels[parseInt(e.target.dataset.index)].style.display = "block";
      if(this.liquidName === "gift-treatments") {
          if (parseInt(e.target.dataset.index) === 0) {
            this.panels.forEach(panel => panel.style.display = "block");
          } else {
             this.panels[parseInt(e.target.dataset.index)].style.display = "block";
          }
      } else if(this.liquidName === "salon-services"){
         if (parseInt(e.target.dataset.index) === 0) {
          this.panels.forEach(panel => panel.style.display = "block");
        } else {
           this.panels[parseInt(e.target.dataset.index)].style.display = "block";
        }
        var tabIndex = parseInt(e.target.dataset.index);
        if (tabIndex === 0 || tabIndex === 1) {
          this.treatmentAddons.style.display = "block";
        } else {
          this.treatmentAddons.style.display = "none";
        }
      }
    }
  }
}

customElements.define('custom-tab-bar', CustomTabBar);

class GoToTopButton extends HTMLElement {
  constructor() {
    super();
    this.anchor = this.querySelector("a");
    window.addEventListener("scroll", this.scroll.bind(this));
  }
  
  scroll() {
    
    
    if(window.scrollY > window.screen.height / 2) {
      this.anchor.style.display = "block";
    }
    else {
      this.anchor.style.display = "none";
    }
  }
}

customElements.define('go-to-top-button', GoToTopButton);


class QuotesViewer extends HTMLElement {
  
  constructor() {
    super();
    this.logos = this.querySelectorAll('.logo-img'); 
    this.quotes = this.querySelectorAll('.quote-text-container .quote-item');
    this.desktop_min_width = 750;

    if(window.innerWidth > this.desktop_min_width)
      this.logos.forEach(tab => tab.addEventListener('click', this.handleLogoOnClick.bind(this)));
  }

  handleLogoOnClick (e) {
    e.preventDefault();
    e.stopPropagation();
    const step = (e.currentTarget.dataset.index || 1) - 1;
    this.quotes.forEach((q,i) => { if(i !== step) q.classList.remove('active') });
    this.logos.forEach((l,i) => l.classList.remove('active'));

    e.currentTarget.classList.add('active');
    this.quotes[step].classList.add("active");
  }
  
}

customElements.define('quotes-viewer', QuotesViewer);

Date.prototype.addHours = function(h) {
  this.setTime(this.getTime() + (h*60*60*1000));
  return this;
}

const getEstOffset = () => {
    const stdTimezoneOffset = () => {
        var jan = new Date(0, 1)
        var jul = new Date(6, 1)
        return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset())
    }

    var today = new Date()
    
    const isDstObserved = (today) => {
        return today.getTimezoneOffset() < stdTimezoneOffset()
    }

    if (isDstObserved(today)) {
        return -4
    } else {
        return -5
    }
}

class CountDownTimer extends HTMLElement {
  constructor() {
    super();
    this.dateInput = this.querySelector("input#timer_time");
    this.daylightOffsetInput = this.querySelector("input#timer_savings");
    this.timerContainer = this.querySelector("span.announcement-bar__timer");
    this.holidayStyle = this.querySelector("input#timer_holiday");

    
    let initialDate = new Date(this.dateInput.value);
    let hourOffset = parseInt(this.daylightOffsetInput.value) - initialDate.getTimezoneOffset() / 60;
    let holidayStyleVal = this.holidayStyle.value;

    console.log('hourOffset');
    console.log(hourOffset);
    console.log(this.daylightOffsetInput.value);
    /*console.log(initialDate);
    console.log(new Date());
    console.log(new Date().toLocaleTimeString("en-US", {timeZone: 'America/New_York'}));*/
    // Update the count down every 1 second
var x = setInterval(function(container) {

  // Get today's date and time
  var now = new Date();
  now.addHours(-1 * hourOffset);

  
  // Find the distance between now and the count down date
  var distance = initialDate.getTime() - now.getTime();

  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  let resultTime = '';

if(holidayStyleVal == 'true') {
    if(days > 0) 
    resultTime += '<span class="c-days c-square"><span class="num">' + days + '</span><span class="txt">DAYS</span></span>';
  if(days > 0 || hours > 0) 
    resultTime += '<span class="c-hours c-square"><span class="num">' + hours + '</span><span class="txt">HOURS</span></span>';

  if(days > 0 || hours > 0 || minutes > 0) 
  {

    resultTime += '<span class="c-minutes c-square"><span class="num">' + (minutes < 10 ? '0' : '') + minutes + '</span><span class="txt">MINUTES</span></span>';
    
  }

  if(days > 0 || hours > 0 || minutes > 0 || seconds > 0) 
  {
   resultTime += '<span class="c-seconds c-square"><span class="num">' + (seconds < 10 ? '0' : '') + seconds + '</span><span class="txt">SECONDS</span></span>';
  }
}
  else {
    if(days > 0) 
      resultTime += days + "d : ";
    if(days > 0 || hours > 0) 
      resultTime += hours + "h : ";
  
    if(days > 0 || hours > 0 || minutes > 0) 
    {
      if(minutes < 10) {
        resultTime += "0";
      }
      resultTime += minutes + "m : ";
      
    }
  
    if(days > 0 || hours > 0 || minutes > 0 || seconds > 0) 
    {
      
      if(seconds < 10) {
        resultTime += "0";
      }
      resultTime += seconds + "s";
    }    
  }

  
  // Display the result in the element with id="demo"
  container.innerHTML = resultTime;

  // If the count down is finished, write some text
  /*if (distance < 0) {
    clearInterval(x);
    document.getElementById("demo").innerHTML = "EXPIRED";
  }*/
}, 1000, this.timerContainer);
  }
  
}

customElements.define('countdown-timer', CountDownTimer);

class ExpandContent extends HTMLElement {
  constructor() {
    super();
    this.expandElement = document.querySelector(this.dataset.expandElement);
    this.anchor = this.querySelector("a");
    this.anchor.addEventListener(
      "click",
      this.handleClickExpand.bind(this)
    );
  }

  handleClickExpand(e) {
    e.preventDefault();
    this.expandElement.removeAttribute("hidden");
    this.anchor.setAttribute("style", "display: none");
  }
}

customElements.define("expand-content", ExpandContent);

class CartTotalProgressBar extends HTMLElement {
  constructor() {
    super();
    this.cartTotalElem = this.querySelector("#cart-total");
    this.shippingTreshHoldElem = this.querySelector("#shipping-treshhold");
    this.sectionElem = this.querySelector(".shopify-section");
    this.progressElem = this.querySelector(".free-shipping");

    if(this.sectionElem.classList.contains('hidden')) 
    {
      console.log('Shipping TreshHold: ' + this.shippingTreshHoldElem.value);
      console.log('Cart Value: ' + this.cartTotalElem.value);
      console.log('Conversion rate: ' + Shopify.currency.rate);

      let shippingVal = parseFloat(this.shippingTreshHoldElem.value);
      let diff = shippingVal - parseFloat(this.cartTotalElem.value) / Shopify.currency.rate
      let percent = diff * 100 / shippingVal;

      percent = 100 - (percent <= 0 ? 0 : percent);

      console.log('Percent: ' + percent);
      
      this.progressElem.style.setProperty("--treshold-percentage", percent.toString() + "%");
      this.sectionElem.classList.remove('hidden');
    }
    
  }

}

customElements.define("cart-total-progress-bar", CartTotalProgressBar);

document.addEventListener('DOMContentLoaded', function() {
  var buttons = document.querySelectorAll("[name=add]");
  buttons.forEach(button => {
    //console.log(button)
    let productUrlAttr = button.getAttribute("data-product-url");
    let buttonClicked = ''
    if (button.className.indexOf('product-form__submit') > -1) {
         buttonClicked = 'Product Page Regular';
     } else  {
      buttonClicked = 'Category Page Regular';
     }
        
    if(!productUrlAttr){
      button.addEventListener('click', (event) => {
        
        mbga4.buttonClicked('CartButtonClicked', buttonClicked, '')
      });
    }
  });
//=================================
hoverVideoPlayEvents(document);
});

function hoverVideoFunc(event) {
  let video = event.target.querySelector(".media.media--hover-effect video");
  if(video) {
    video.load();
  }
}

function hoverVideoPlayEvents(parentElem) {
  parentElem.querySelectorAll(".card-wrapper").forEach((cardHover) => {
    cardHover.removeEventListener("mouseenter", hoverVideoFunc);
    cardHover.addEventListener("mouseenter", hoverVideoFunc);
  });
}

function addedToCartKlaviyo(itemAdded) {
  fetch(`${window.location.origin}/cart.js`)
  .then(res => res.clone().json().then(data => {
    var cart = {
      total_price: data.total_price/100,
      $value: data.total_price/100,
      total_discount: data.total_discount,
      original_total_price: data.original_total_price/100,
      items: data.items
    }
    if (window['item'] !== undefined) {
      cart = Object.assign(cart, item)
    }
    else if(itemAdded != undefined){
      newItem = {
        Brand : "Mario Badescu",
        Categories : [itemAdded.product_type],
        ImageURL : itemAdded.image,
        Name :  itemAdded.product_title,
        Price : (itemAdded.final_price / 100).toFixed(2).toString() + "$",
        ProductID : itemAdded.product_id,
        URL : 'https://www.mariobadescu.com' + itemAdded.url
      }
      cart = Object.assign(cart, newItem);
    }

    

    klaviyo.push(['track', 'Added to Cart', cart]);
  }))
};

(function (ns, fetch) {  
  ns.fetch = function() {
    const response = fetch.apply(this, arguments);
    //console.log('arguments', arguments)
    
    let resJson;
    response.then(res => {
      if (`${window.location.origin}/cart/add.js`
      	.includes(res.url) && res.url !== '') {
      
        try {
        
         res.clone().json().then(data => {
           console.log('add', data);
           addedToCartKlaviyo(data)
           let item = {
                    item_id: data.sku,
                    item_name: data.title,
                    item_brand: 'mariobadescu',
                    item_variant: data.variant_title,
                    price: data.price/100,
                    currency: 'USD',
                    quantity: data.quantity
                  }

                  /*fetch('/cart.js', {
                    method: 'GET',
                    headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
                    }).then(function (response) { return response.json(); }).then((response) => {
                      processGwp(response);

                    });*/

              //mbga4.addProductToCart(data.id, data.title, "", data.price/100, data.variant_title,  data.quantity, data.sku);
           
              // window.dataLayer.push({
              //     'event': 'add_to_cart',
              //     'currency': 'USD',
              //     'ecommerce': item
              // });  

           //console.log(item);
         });
        }
        catch(exceptionVar) {}
      }

      if (`${window.location.origin}/cart/change.js`
      	.includes(res.url) && res.url !== '') {
        try {
         res.clone().json().then(data => {
           console.log('change',data);
           //processGwp(data);
            if(data.items.length == 0) {
               fetch('/cart/update.js', {
                  method: 'POST',
                  headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
                  body: JSON.stringify({
                      attributes: {
                          'sample_productIds': '',
                          'sample_productNames': ''
                      }
                  })
            });   
          
         }});
        }
        catch(exceptionVar) {}
      }

      if (`${window.location.origin}/cart/update.js`
      	.includes(res.url) && res.url !== '') {
        try {
         res.clone().json().then(data => {
           console.log('update',data);
           //processGwp(data);
          
         });
          }
        catch(exceptionVar) {}
      }

      if (`${window.location.origin}/cart/clear.js`
      	.includes(res.url) && res.url !== '') {
        try {
         res.clone().json().then(data => {
           console.log('clear',data)
          
          
         });
          }
        catch(exceptionVar) {}
      }

      if (window.location.pathname.includes("search")) {
          mbga4.searchPage(window.location.search);
      }
      
    });
    return response
  }


}(window, window.fetch))

function onVisible(element, callback) {
  new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if(entry.intersectionRatio > 0) {
        callback(element);
        observer.disconnect();
      }
    });
  }).observe(element);
}

var clearForMeToken = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI1ZjQzZGQzZjdjMzAxMzM2OWM4ODJlNTUiLCJjbGllbnRuYW1lIjoibWFyaW8gYmFkZXNjdSIsInVzZXJuYW1lIjoibWFyaW9iYWRlc2N1IiwicGFzc3dvcmQiOiIkMmEkMTAkSkRuS2p3LmFIZHpMb1RvWUVESjRrLnhlSGpJOGFyR1hVdWRWS1NZTjZGL1RwdG4ya2F2WmUiLCJlbWFpbCI6ImtyaXN0eW5hQG1hcmlvYmFkZXNjdS5jb20iLCJwYWNrYWdlIjoidWx0YSBjb25zY2lvdXMgYmVhdXR5IiwicGVybWlzc2lvbiI6Im93bmVyIiwiaWF0IjoxNjMyMjQ5NzgxfQ.M-fTXj-1jsU6RZ1_2y7twQndJ-TMYo8qrugA1hi86-o';
var clearForMeClientName = 'mario badescu';

function getIngredients(sku) {
  return fetch('https://server.clearforme.com/api/app/products/details?sku=' + sku + '&clientname=' + clearForMeClientName, {
  method: 'GET',
  headers: {'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': clearForMeToken}
  }).then(function (response) { return response.json(); })
  .then(function(data){
        let container = [];
        let attributes = [];
    
        if (data.productDetails && data.productDetails.productAttributes && data.productDetails.productAttributes.length > 0) {
            data.productDetails.productAttributes.forEach(function (attr) {
                if (attributes.indexOf(attr.attribute) == -1) {
                    attributes.push(attr.attribute);
                }
            });
        }
    
        if (data.productIngredients && data.productIngredients.length > 0) {

          data.productIngredients.forEach(function (ingredientItem) {
              var ings = [];
              ingredientItem.functionGroup.forEach(function (group) {
                  group.ingredients.forEach(function (ingredient) {
                      if (ingredient.ingredientName) {
                          var name = ingredient.ingredientName;
                          ings.push({ name: name });
                      }
                  });
              });
              container.push({ productName: ingredientItem.component, ingredients: ings });
          });

      
    }

    return {container: container, attributes : attributes};
  }).catch(function (err) {console.warn('Get Ingredients Error', err);});
}

function getIngredientInfo(sku, name) {
  return fetch('https://server.clearforme.com/api/app/ingredients/definition?sku=' + sku + '&ingredientName=' + name + '&clientname=' + clearForMeClientName, {
  method: 'GET',
  headers: {'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': clearForMeToken}
  }).then(function (response) { return response.json(); })
  .then(function(data){
    return data.definition;
  }).catch(function (err) {console.warn('Get Ingredient Info Error', err);});
}

function getRealWidth() {
  return Math.max(
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth,
    document.documentElement.clientWidth
  );
}

function checkDuplicates(str) {
  let a = str.split(',');
  let arr = a.filter(function(item, pos, self) {
      return self.indexOf(item) == pos;
  });
  return arr.join();
}

function addSkinAnalysisSamples(productIds, productNames, callback) {
  /*fetch('/cart/update.js', {
    method: 'POST',
    headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
    body: JSON.stringify({
        attributes: {
            'sa_sample_productIds': productIds,
            'sa_sample_productNames': productNames
        }
    })
}).then(function (response) { return response.json(); })
   .then(function(data){
     callback(true);
   }).catch(function (err) {callback(false);});;*/

   if(!productIds || !productNames || productIds.length == 0 || productNames.length == 0) {
    return;
   }

  productIds = checkDuplicates(productIds);

  productNames = checkDuplicates(productNames);

  console.log('ProductIds ' + productIds);
  console.log('ProductNames ' + productNames);
   let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

   cart.setActiveElement(document.activeElement);

    fetch('/cart.js', {
                method: 'GET',
                headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
            }).then(function (response) { return response.json(); }).then((response) => {
        let inArray = false;
        for(var i = 0; i< response.items.length; i++){
            if(response.items[i].variant_id == window.sampleCollectionProperties.variantId){
                inArray = true; 
                break;
            }
        }
          if(!inArray) {
            fetch(`${routes.cart_add_url}`, {
              method: 'POST',
              headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
              body: JSON.stringify({
                quantity: 1,
                id: window.sampleCollectionProperties.variantId,
                properties: {
                      '_sample_productIds': productIds,
                      'Samples': productNames
                  },
                sections: cart.getSectionsToRender().map((section) => section.id),
                sections_url: window.location.pathname
              })
          }).then(function (response) { return response.json(); }).then((response) => {
            cart.renderContents(response);
            if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          })
             .then(function(data){
               callback(true);
             }).catch(function (err) {callback(false);});;
          }
          else {
            //alert('Already added');
            /*if(!cart.querySelector('tr[data-product-id="'+window.sampleCollectionProperties.productId+'"] td.cart-item__details .error')) {
                cart.querySelector('tr[data-product-id="'+window.sampleCollectionProperties.productId+'"] td.cart-item__details').innerHTML += '<p class="error" style="color:Red">Samples already added to your cart</p>';
            }*/
            cart.querySelector('tr[data-product-id="'+window.sampleCollectionProperties.productId+'"] .cart-item__error .cart-item__error-text').innerText = 'Samples already added to your cart';
            setTimeout(() => {
              cart.querySelector('#CartDrawer-Overlay').addEventListener('click', cart.close.bind(this));
              cart.open();
            });
          }
        
      
      });
  

}

/*function addGwpVariantToCart(variantId, cart) {
  fetch(`${routes.cart_add_url}`, {
    method: 'POST',
    headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
    body: JSON.stringify({
      quantity: 1,
      id: variantId,
      sections: cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    })
}).then(function (response) { return response.json(); }).then((response) => {
  cart.setActiveElement(document.activeElement);
  cart.renderContents(response);
  if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
})
   .then(function(data){
     callback(true);
   }).catch(function (err) {callback(false);});;
}

function removeGwpVariantToCart(lineNum, cart, showCart = true) {
  fetch(`${routes.cart_change_url}`, {
    method: 'POST',
    headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
    body: JSON.stringify({
      quantity: 0,
      line: lineNum,
      sections: cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    })
}).then(function (response) { return response.json(); }).then((response) => {
  if(showCart) {
    cart.setActiveElement(document.activeElement);
    cart.renderContents(response);
    cart.classList.toggle('is-empty', response.item_count === 0);
  }
})
   .then(function(data){
     callback(true);
   }).catch(function (err) {callback(false);});;
}

function processGwp(response) {

  if(window.gwp.gwp_threshold_1 === 0 && window.gwp.gwp_threshold_2 === 0)
    return;

  let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    let inArrayVariant = 0;
    let lineNum = 0;
    let variantId = 0;
    

    if(window.gwp.gwp_threshold_2 !== 0 && response.items_subtotal_price >=  window.gwp.gwp_threshold_2)
      variantId = window.gwp.gwp_product_2;
    else if(window.gwp.gwp_threshold_1 !== 0 && response.items_subtotal_price >=  window.gwp.gwp_threshold_1)
      variantId = window.gwp.gwp_product_1;

      for(var i = 0; i< response.items.length; i++){
        if(response.items[i].variant_id == window.gwp.gwp_product_2 || response.items[i].variant_id == window.gwp.gwp_product_1){
          inArrayVariant = response.items[i].variant_id;
          lineNum = i + 1;
          break;
        }
    }
  
    if(inArrayVariant === 0 && variantId !== 0) {
      addGwpVariantToCart(variantId, cart);
    }
    else if(inArrayVariant !== 0 && variantId === 0) {
      removeGwpVariantToCart(lineNum, cart);
    }
    else if(inArrayVariant !== 0 && variantId !== 0 && inArrayVariant != variantId) {
      removeGwpVariantToCart(lineNum, cart, false);
      addGwpVariantToCart(variantId, cart);
    }

}*/

function addQuizResultToCart(formData, callback) {
  let items = formData.items.reduce((unique, o) => {
    if(!unique.some(obj => obj.id === o.id) && o.id !== '43863994073315') {
      unique.push(o);
    }
    return unique;
  },[]);
  let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  fetch(`${routes.cart_add_url}`, {
    method: 'POST',
    headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
    body: JSON.stringify({
      items: items,
      sections: cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
      
    })
}).then(function (response) { return response.json(); }).then((response) => {
    
  cart.setActiveElement(document.activeElement);
  cart.renderContents(response);
  if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
})
   .then(function(data){
     if(callback)
       callback(true);
   }).catch(function (err) {
     if(callback)
       callback(false);
   });;
}

function addQuizResultToCartTest() {
  let formData = {
 'items': [{
  'id': 43863987355875,
  'quantity': 2
  },
          {
  'id': 43863987388643,
  'quantity': 1
  }]
};
  addQuizResultToCart(formData);
}

function addTestProductToCart() {
  let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  addGwpVariantToCart('43863996694755', cart);
}

function openNotifyMePopup(formId) {
  window._klOnsite = window._klOnsite || [];
window._klOnsite.push(['openForm', formId]);
}

function reloadCartDrawer() {
  
    let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  fetch(`https://www.mariobadescu.com/?sections=cart-drawer`, {
    method: 'GET',
    headers: {'Accept': 'application/json', 'Content-Type': 'application/json'}
}).then(function (response) { return response.json(); }).then((response) => {
          let sectionElem = document.querySelector("#CartDrawer");
      sectionElem.innerHTML =
          cart.getSectionInnerHTML(response["cart-drawer"], "#CartDrawer");
});
}